import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";

export default function BankingAccountsTable({
  bankingAccounts,
  handleSelectedAccount,
}) {
  const onSelectAccount = (account, index) => {
    console.log("index :>> ", index);
    handleSelectedAccount(account, index);
  };

  if (!bankingAccounts) {
    return (
      <div style={{ padding: 15 }}>
        <Typography variant="h5">
          Dieser Account enthält noch keine Bankkonten
        </Typography>
      </div>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Inhaber</TableCell>
            <TableCell align="left">IBAN</TableCell>
            <TableCell align="left">Gläubiger-ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bankingAccounts.map((row, i) => (
            <TableRow
              onClick={() => onSelectAccount(row, i)}
              hover
              key={row.creditorName + i.toString()}
            >
              <TableCell component="th" scope="row">
                {row.creditorName}
              </TableCell>
              <TableCell align="left">{row.creditorIBAN}</TableCell>
              <TableCell align="left">{row.creditorId}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
